module.exports = __webpack_public_path__ + "img/giftpackage_level3.f8f3456d.png";